// src/layouts/MainLayout.js

import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useI18n } from '../i18n/i18nService'; // Assurez-vous que i18n est correctement configuré
import { Link, useLocation } from 'react-router-dom'; // Importe Link et useLocation
import { ChevronRightIcon } from '@heroicons/react/24/outline';
// Importe les composants de layout spécifiques (à créer dans src/components/layout/)
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import Footer from '../components/layout/Footer';

// Composant MainLayout qui gère la structure globale de l'application
// Il reçoit `children` qui est le contenu de la page actuelle rendu par le routeur
function MainLayout({ children }) {
    const { t, i18n } = useI18n();
    const location = useLocation(); // Hook de react-router-dom pour obtenir l'objet de localisation actuel
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    // Fonction pour changer la langue
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        // reload the page to apply the language change
        window.location.reload();
    };

    // Génère les breadcrumbs dynamiquement
    const generateBreadcrumbs = () => {
        const paths = location.pathname.split('/').filter(Boolean);
        return paths.map((segment, index) => ({
            name: t(segment) || segment,
            path: `/${paths.slice(0, index + 1).join('/')}`,
            current: index === paths.length - 1
        }));
    };

    return (
        <div className="min-h-screen bg-light-bg dark:bg-dark-bg text-light-text dark:text-dark-text transition-colors duration-300">
            {/* En-tête de l'application */}
            <Header
                changeLanguage={changeLanguage}
                currentLanguage={i18n.language}
                onOpenSidebar={() => setIsSidebarOpen(true)}
            />

            {/* Contenu principal et barre latérale */}
            <div className="flex flex-col md:flex-row">
                {/* Barre latérale de navigation */}
                <div className="hidden md:block">
                    <Sidebar currentPagePath={location.pathname} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                </div>
                {isSidebarOpen && (
                    <div
                        className="fixed inset-0 z-30 bg-black bg-opacity-50 md:hidden"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}
                {/* Zone de contenu principale (où les pages seront rendues) */}
                <main className="flex-1 p-4 md:p-6 overflow-y-auto bg-light-surface dark:bg-dark-surface min-h-[calc(100vh-64px)]">
                    <div className="mx-auto">
                        <nav className="mb-6">
                            <ol className="flex items-center space-x-2 text-sm">
                                <li>
                                    <Link to="/" className="text-light-tertiary dark:text-dark-tertiary hover:text-light-primary dark:hover:text-dark-primary">
                                        {t('home')}
                                    </Link>
                                </li>
                                {generateBreadcrumbs().map((crumb, i) => (
                                    <React.Fragment key={i}>
                                        <ChevronRightIcon className="h-4 w-4 text-light-tertiary dark:text-dark-tertiary" />
                                        <li>
                                            {crumb.current ? (
                                                <span className="font-medium text-light-primary dark:text-dark-primary">
                                                    {crumb.name}
                                                </span>
                                            ) : (
                                                <Link
                                                    to={crumb.path}
                                                    className="text-light-tertiary dark:text-dark-tertiary hover:text-light-primary dark:hover:text-dark-primary"
                                                >
                                                    {crumb.name}
                                                </Link>
                                            )}
                                        </li>
                                    </React.Fragment>
                                ))}
                            </ol>
                        </nav>

                        {/* Contenu des pages */}
                        {children} {/* Le contenu de la page actuelle est rendu ici par le routeur */}
                        {/* Pied de page */}

                    </div>

                </main>

            </div>
            <Footer />
        </div>
    );
}

export default MainLayout;
